import React, { Component, Fragment } from 'react';
import { Menu, Dropdown, Layout, Modal, Drawer, Icon } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { updateUserSettingSaga } from '~/redux/userSetting'
import { FormattedMessage, injectIntl } from 'react-intl';
import { config, Languages, getImageUrl, ThemeType, getValue4Lang, isSafe2Travel, isEmpty, getProfileToken, getError, loadFont } from '~/common';
import { connect } from 'react-redux';
import { QRCode, CTMModal, Loading } from '~/components';
import { stopHubConnection, startHubConnection } from '~/redux/sso';
import { getCtmMobileDownload, getGenericContent, resetMFA } from '~/client'
import { ThemeIcon, LanguageIcon, MobileIcon, LogoutIcon, PhoneIcon, EmailIcon, SwitchIcon, ResetMFAIcon } from '~/components/SvgIcon';

// import { ReactComponent as SwitchIcon } from '~/components/SvgIcon/switch.svg';

const Menus = {
    theme: "theme",
    language: "language",
    region: "region",
    contactUs: "contactUs"
}
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userMenuVisible: false,
            selectedMenu: undefined,
            ctmMobileDownload: undefined,
            showCtmMobileDownload: false,
            contactUsContent: '',
        };
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }


    handleLangChange = lang => {
        this.setState({ userMenuVisible: false });
        this.props.changeLocale(lang);
    }

    handleThemeChange = themeType => {
        this.setState({ userMenuVisible: false });
        this.props.toggleThemeMode(themeType);
        document.body.classList.remove('light-mode', 'dark-mode');
        document.body.classList.add(themeType === ThemeType.Breezy ? 'light-mode' : 'dark-mode');
    }
    handleShowCtmMobileDownload = async () => {
        this.setState({ userMenuVisible: false });
        if (!this.state.ctmMobileDownload) {
            this.setState({ loading: true });
            let results = await getCtmMobileDownload({ token: config.obtApiToken });
            this.setState({ ctmMobileDownload: results, loading: false });
        }
        this.state.ctmMobileDownload && CTMModal.info({
            maskClosable: true,
            className: "mobile-download-modal",
            title: this.state.ctmMobileDownload.Title,
            centered: true,
            content: <>
                <div>{this.state.ctmMobileDownload.Content}</div>
                <div className='mobile-download-wrap'>
                    {this.state.ctmMobileDownload && this.state.ctmMobileDownload.Links && this.state.ctmMobileDownload.Links.map((link, index) => <a rel="noopener noreferrer" target="_blank" href={link.Link} key={index}>
                        <img src={link.Image} alt={link.Key} />
                        {link.Key === "QRCode" && <div>{this.props.intl.formatMessage({ id: 'download_link' })}</div>}
                    </a>
                    )}
                </div>
            </>
        })
    }
    handleShowResetMFA = () => {
        this.setState({ userMenuVisible: false });
        loadFont().then(() => {
            CTMModal.confirm({
                centered: true,
                title: this.props.intl.formatMessage({ id: 'reset_mfa_msg' }),
                okText: this.props.intl.formatMessage({ id: 'signout' }),
                cancelText: this.props.intl.formatMessage({ id: 'cancel' }),
                onOk: () => {
                    const params = {
                        profileToken: getProfileToken(),
                        Email: this.props.email,
                        CompanyId: this.props.companyId,
                    }
                    return resetMFA(params, (err, rs) => {
                        const errMsg = getError(rs);
                        if (errMsg) {
                            Modal.error({
                                centered: true,
                                title: this.props.intl.formatMessage({ id: 'system_information' }),
                                content: errMsg,
                            });
                            return;
                        }
                        this.props.history.replace('/logout');
                    });
                },
                confirmLoading: true
            });
        });
    }


    handleShowContactUs = async () => {
        this.setState({ userMenuVisible: false });
        if (!this.state.contactUsContent) {
            this.setState({ loading: true });
            const rs = await getGenericContent({ profileToken: getProfileToken(), category: 'PortalContactUs', keyword: 'menu' });
            this.setState({ loading: false, contactUsContent: rs.Content });
            const errMsg = getError(rs);
            if (errMsg) {
                Modal.error({
                    centered: true,
                    title: this.props.intl.formatMessage({ id: 'system_information' }),
                    content: errMsg,
                });
                return;
            }
        }
        CTMModal.info({
            maskClosable: true,
            className: "menu-contact-us-modal",
            centered: true,
            content: <div dangerouslySetInnerHTML={{ __html: this.state.contactUsContent }}></div>
        });
    }


    render() {
        const { locale, userName, enableLoginByQRCode4Mobile, auth, shortName, themeType, availLanguages, availCTMPortalAreas, contactUs, enableMFAReset, showMenuContactUs } = this.props;
        const { userMenuVisible, loading, selectedMenu } = this.state;
        const userMenu = (
            <div>
                <Menu className='clearfix'>
                    <Menu.Item className='expand' onClick={() => this.setState({ selectedMenu: Menus.theme })} >
                        <div><ThemeIcon /><FormattedMessage id="light_dark_mode" /></div>
                    </Menu.Item>
                    {(!availLanguages || availLanguages.length > 1) && <Menu.Item className='expand' onClick={() => this.setState({ selectedMenu: Menus.language })}>
                        <div><LanguageIcon /><FormattedMessage id="select_language" /></div>
                    </Menu.Item>}
                    {(availCTMPortalAreas || []).length > 0 && <Menu.Item className='expand' onClick={() => this.setState({ selectedMenu: Menus.region })}>
                        <div><SwitchIcon /><FormattedMessage id="select_region" /></div>
                    </Menu.Item>}
                    {showMenuContactUs && <Menu.Item onClick={() => this.handleShowContactUs()}>
                        <div><PhoneIcon /><FormattedMessage id="contact_us" /></div>
                    </Menu.Item>}
                    {enableLoginByQRCode4Mobile && <Menu.Item onClick={() => this.handleShowCtmMobileDownload()} >
                        <div><MobileIcon /><FormattedMessage id="download_ctm_mobile_app" /></div>
                    </Menu.Item>}
                    {enableMFAReset && <Menu.Item onClick={() => this.handleShowResetMFA()} >
                        <div><ResetMFAIcon /><FormattedMessage id="reset_mfa" /></div>
                    </Menu.Item>}
                    <Menu.Item>
                        <Link to='/logout'><LogoutIcon /><FormattedMessage id="logout" /></Link>
                    </Menu.Item>
                    {/* {enableLoginByQRCode4Mobile && <Menu.Item style={{ "cursor": "pointer" }} onClick={this.showQRCodeModal}>
                    <FormattedMessage id="login_for_mobile" />
                </Menu.Item>} */}

                </Menu>
                <Drawer
                    width={"100%"}
                    title={<div className='drawer-title'>
                        <div className='back' onClick={() => this.setState({ selectedMenu: undefined })}></div>
                        {selectedMenu === Menus.theme && <FormattedMessage id="light_dark_mode" />}
                        {selectedMenu === Menus.language && <FormattedMessage id="select_language" />}
                        {selectedMenu === Menus.region && <FormattedMessage id="select_region" />}
                    </div>}
                    placement="right"
                    closable={false}
                    visible={[Menus.theme, Menus.language, Menus.region].includes(selectedMenu)}
                    getContainer={false}
                    style={{ position: 'absolute' }}
                >
                    {selectedMenu === Menus.theme && <div>
                        {[ThemeType.Breezy, ThemeType.Galaxy].map(enableTheme => {
                            return <div key={enableTheme} className={`drawer-item${themeType === enableTheme ? ' active' : ''}`} onClick={() => this.handleThemeChange(enableTheme)}><FormattedMessage id={{
                                [ThemeType.Galaxy]: 'dark',
                                [ThemeType.Breezy]: 'light'
                            }[enableTheme]} /></div>;
                        })}

                    </div>}
                    {selectedMenu === Menus.language && <div>
                        {(!availLanguages || availLanguages.includes(Languages.en_us)) && <div className={`drawer-item${locale === Languages.en_us ? ' active' : ''}`} onClick={() => this.handleLangChange(Languages.en_us)}><FormattedMessage id="english" /></div>}
                        {(!availLanguages || availLanguages.includes(Languages.zh_tw)) && <div className={`drawer-item${locale === Languages.zh_tw ? ' active' : ''}`} onClick={() => this.handleLangChange(Languages.zh_tw)}><FormattedMessage id="chinese_traditional" /></div>}
                        {(!availLanguages || availLanguages.includes(Languages.zh_cn)) && <div className={`drawer-item${locale === Languages.zh_cn ? ' active' : ''}`} onClick={() => this.handleLangChange(Languages.zh_cn)}><FormattedMessage id="chinese_simplified" /></div>}
                        {(!availLanguages || availLanguages.includes(Languages.ja_jp)) && <div className={`drawer-item${locale === Languages.ja_jp ? ' active' : ''}`} onClick={() => this.handleLangChange(Languages.ja_jp)}><FormattedMessage id="japanese" /></div>}
                    </div>
                    }
                    {this.state.selectedMenu === Menus.region && <div>
                        {availCTMPortalAreas.map(item => <div key={item.Code} className={`region drawer-item${(availCTMPortalAreas.find(v => v.IsSelected) || {}).Code === item.Code ? ' active' : ''}`} onClick={() => {
                            item.URL && window.setTimeout(() => window.open(item.URL));
                            this.setState({ userMenuVisible: false });
                        }} >
                            <div>
                                <div>{item.Embranchment || ""}</div>
                                {getValue4Lang(item.Name, item.NameZhCn, item.NameZhTw, item.NameJaJp)}
                            </div>
                            {/* {item.IsExternalLink && (availCTMPortalAreas.find(v => v.IsSelected) || {}).Code !== item.Code && <span className='ctm-external-link-icon'></span>} */}
                        </div>)}
                    </div>
                    }
                </Drawer>
            </div>
        );

        return (
            <Layout.Header className='header ctm-header'>
                {loading && <Loading style={{ color: 'white', position: 'fixed' }} />}
                <div className="ctm-header-logo"><Link to='/'><img src={getImageUrl(isSafe2Travel() ? 'safe_2_travel_logo_white.svg' : 'ctm_portal_logo.svg')} alt="" /></Link></div>
                <div className='notification-icon beamerTrigger' style={{ display: 'none' }}></div>
                {auth.isAuthenticated() && <div className='profile'>
                    {shortName && <div className='avatar'>{shortName}</div>}
                    <Dropdown overlay={userMenu} trigger={['click']} placement='bottomRight' overlayClassName='profile-popup' visible={userMenuVisible} onVisibleChange={val => this.setState({ userMenuVisible: val, selectedMenu: undefined })}>
                        <a className="ant-dropdown-link">
                            <span className='greeting-desc'><FormattedMessage id='hello' />, {userName}</span>
                            <span className='triangle'></span>
                        </a>
                    </Dropdown>
                    {/* {this.state.QRCodeVisible && <QRCode onCancel={this.handleCancel} />} */}
                </div>}
            </Layout.Header>
        )
    }
}

export default connect(state => ({
    locale: state.userSetting.Language,
    availLanguages: state.userSetting.AvailLanguages,
    availCTMPortalAreas: state.userSetting.AvailCTMPortalAreas,
    userName: getValue4Lang(state.user.name, state.user.nameZhCn, state.user.nameZhTw, state.user.nameJaJp),
    themeType: state.userSetting.ThemeType,
    enableLoginByQRCode4Mobile: state.user.enableLoginByQRCode4Mobile,
    enableMFAReset: state.user.enableMFAReset,
    email: state.user.email,
    companyId: state.user.companyId,
    shortName: state.user.shortName,
    showMenuContactUs: state.user.showMenuContactUs,
}), dispatch => ({
    changeLocale: lang => dispatch(updateUserSettingSaga({ Language: lang })),
    toggleThemeMode: themeType => dispatch(updateUserSettingSaga({ ThemeType: themeType })),
    startHubConnection: () => dispatch(startHubConnection()),
    stopHubConnection: () => dispatch(stopHubConnection())
}))(withRouter(injectIntl(Header)));
